export { sanitize } from 'isomorphic-dompurify'
